<template>
    <div>
        <vue-dropzone @vdropzone-file-added="vfileAdded"
                      @vdropzone-success="vsuccess"
                      @vdropzone-error="verror"
                      @vdropzone-removed-file="vremoved"
                      @vdropzone-sending="vsending"
                      @vdropzone-success-multiple="vsuccessMultiple"
                      @vdropzone-sending-multiple="vsendingMultiple"
                      @vdropzone-queue-complete="vqueueComplete"
                      @vdropzone-total-upload-progress="vprogress"
                      :ref="zone_ref"
                      :id="custom_style_id"
                      :include-styling="false"
                      :useCustomSlot=true
                      @vdropzone-thumbnail="thumbnail"
                      :options="dropZoneOptions">
            <div class="dropzone-custom-content">
                <h3 class="dropzone-custom-title">{{ zone_message }}</h3>
                <div class="subtitle">{{ zone_subtitle }}</div>
            </div>
        </vue-dropzone>
    </div>
</template>
<script>
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    export default {
        data() {
            return Object.assign({
                media: {
                    fileAdded: false,
                    filesAdded: false,
                    success: false,
                    error: false,
                    removedFile: false,
                    sending: false,
                    successMultiple: false,
                    sendingMultiple: false,
                    queueComplete: false,
                    uploadProgress: false,
                    progress: false,
                    myProgress: 0,
                },
                dropZoneOptions: {
                    url: this.upload_url,
                    thumbnailWidth: this.thumbnail_width,
                    thumbnailHeight: this.thumbnail_height,
                    thumbnailMethod: this.thumbnail_method,
                    acceptedFiles: this.accepted_files,
                    autoProcessQueue: this.auto_process_queue,
                    autoQueue: this.auto_queue,
                    addRemoveLinks: this.add_remove_links,
                    duplicateCheck: this.duplicate_check,
                    parallelUploads: this.parallel_uploads,
                    dictDefaultMessage: this.zone_message,
                    dictFileTooBig: 'testing',
                    previewTemplate: this.template(),
                    paramName: this.custom_file_param,
                    headers: {
                        'X-CSRF-TOKEN': '',
                    }
                }
            }, {locale: window.locale});
        },
        components: {
            vueDropzone: vue2Dropzone
        },
        props: {
            is_debug: {
                required: false,
                type: Boolean,
                default: false,
            },
            zone_ref: {
                required: false,
                type: String,
                default: 'myVueDropZone'
            },
            custom_style_id: {
                required: false,
                type: String,
                default: 'custom_drop_zone'
            },
            zone_message: {
                required: false,
                type: String,
                default: '',
            },
            zone_subtitle: {
                required: false,
                type: String,
                default: '',
            },
            upload_url: {
                required: true,
                type: String,
                default: ''
            },
            thumbnail_width: {
                required: false,
                type: Number,
                default: 160
            },
            thumbnail_height: {
                required: false,
                type: Number,
                default: 160
            },
            thumbnail_method: {
                required:false,
                type: String,
                default: 'crop',
            },
            accepted_files: {
                required: false,
                type: String,
                default: "image/*,"
            },
            auto_process_queue: {
                required: false,
                type: Boolean,
                default: true
            },
            auto_queue: {
                required: false,
                type: Boolean,
                default: true
            },
            add_remove_links: {
                required: false,
                type: Boolean,
                default: true
            },
            duplicate_check: {
                required: false,
                type: Boolean,
                default: true
            },
            parallel_uploads: {
                required: false,
                type: Number,
                default: 1,
            },
            extract_progress_status: {
                required: false,
                type: Boolean,
                default: false,
            },
            extract_progress_status_event: {
                required: false,
                type: String,
                default: '',
            },
            custom_file_param: {
                required: false,
                type: String,
                default: 'file',
            },
            upload_success_remove_file: {
                required: false,
                type: Boolean,
                default: true
            },
        },
        mounted() {
            this.dropZoneOptions.headers['X-CSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
        },
        methods: {
            vfileAdded(file) {
                let self = this;
                self.media.queueComplete = false;
                self.media.fileAdded = true;
                // file.previewElement.addEventListener("click", function() {
                //     self.$refs[self.zone_ref].removeFile(file);
                // });
                if (self.is_debug)
                {
                    console.log('vfileAdded:');
                    console.log(file);
                }
                if (this.extract_progress_status)
                {
                    let event_param = {
                        status: 'file_added',
                        file_info: {
                            name: _.isUndefined(file) ? null : file.name,
                            size: _.isUndefined(file) ? null : file.size,
                            type: _.isUndefined(file) ? null : file.type
                        }
                    };
                    window.eventHub.$emit(this.extract_progress_status_event, event_param);
                }
            },
            vfilesAdded(file) {
                let self = this;
                self.media.filesAdded = true;
                self.media.queueComplete = false;
                if (self.is_debug)
                {
                    console.log('vfilesAdded:');
                    console.log(file);
                }
                if (this.extract_progress_status)
                {
                    let event_param = {
                        status: 'files_added',
                        file_info: {
                            name: _.isUndefined(file) ? null : file.name,
                            size: _.isUndefined(file) ? null : file.size,
                            type: _.isUndefined(file) ? null : file.type
                        }
                    };
                    window.eventHub.$emit(this.extract_progress_status_event, event_param);
                }
            },
            vsuccess(file, response) {
                let self = this;
                self.media.success = true;
                if (self.is_debug)
                {
                    console.log('vsuccess:');
                    console.log(file);
                    console.log(response);
                }
                if (!_.isUndefined(response.msg))
                {
                    this.$store.commit('setNotification', response.msg + ' (' + file.name + ')');
                    if (self.upload_success_remove_file) {
                        self.$refs[self.zone_ref].removeFile(file);
                    }

                }
                if (this.extract_progress_status)
                {
                    let event_param = {
                        status: 'success',
                        response: response,
                        file_info: {
                            name: _.isUndefined(file) ? null : file.name,
                            size: _.isUndefined(file) ? null : file.size,
                            type: _.isUndefined(file) ? null : file.type
                        }
                    };
                    window.eventHub.$emit(this.extract_progress_status_event, event_param);
                }
            },
            verror(file, message, xhr) {
                this.media.error = true;
                if (this.is_debug)
                {
                    console.log('verror:');
                    console.log(file);
                    console.log(message);
                    console.log(xhr);
                }
                let ref = file.previewElement.querySelectorAll("[data-dz-errormessage]");

                let error_elm = _.first(ref);
                let parent_elm = error_elm.parentElement;
                if (_.isUndefined(message.errors))
                {
                    parent_elm.innerHTML = message.msg;
                    parent_elm.classList.remove('custom_error_msg');
                    parent_elm.classList.add('dz-error-message');
                    error_elm.remove();
                } else {
                    parent_elm.innerHTML = !_.isUndefined(message.errors[this.custom_file_param])
                        ? message.errors[this.custom_file_param][0]
                        : 'failed';
                    parent_elm.classList.add('custom_error_msg');
                    parent_elm.classList.remove('dz-error-message');
                    error_elm.remove();
                }
                if (this.extract_progress_status)
                {
                    let event_param = {
                        status: 'error',
                        message: error_elm.innerHTML,
                        xhr: xhr,
                        file_info: {
                            name: _.isUndefined(file) ? null : file.name,
                            size: _.isUndefined(file) ? null : file.size,
                            type: _.isUndefined(file) ? null : file.type
                        }
                    };
                    window.eventHub.$emit(this.extract_progress_status_event, event_param);
                }
            },
            vremoved(file, xhr, error) {
                this.media.removedFile = true;
                if (this.is_debug)
                {
                    console.log('vremoved:');
                    console.log(file);
                    console.log(xhr);
                    console.log(error);
                }
                if (this.extract_progress_status)
                {
                    let event_param = {
                        status: 'file_removed',
                        xhr: xhr,
                        error: error,
                        file_info: {
                            name: _.isUndefined(file) ? null : file.name,
                            size: _.isUndefined(file) ? null : file.size,
                            type: _.isUndefined(file) ? null : file.type
                        }
                    };
                    window.eventHub.$emit(this.extract_progress_status_event, event_param);
                }
            },
            vsending(file, xhr, formData) {
                this.media.sending = true;
                formData.append('file_size', file.size);
                formData.append('file_name', file.name);
                if (this.is_debug)
                {
                    console.log(this.dropZoneOptions.url);
                    console.log('vsending:');
                    console.log(file);
                    console.log(xhr);
                    console.log(formData);
                }
                if (this.extract_progress_status)
                {
                    let event_param = {
                        status: 'file_sending',
                        xhr: xhr,
                        formData: formData,
                        file_info: {
                            name: _.isUndefined(file) ? null : file.name,
                            size: _.isUndefined(file) ? null : file.size,
                            type: _.isUndefined(file) ? null : file.type
                        }
                    };
                    window.eventHub.$emit(this.extract_progress_status_event, event_param);
                }
            },
            vsuccessMultiple(files, response) {
                this.media.successMultiple = true;
                if (this.is_debug)
                {
                    console.log('vsuccessMuliple:');
                    console.log(file);
                    console.log(response);
                }
                if (this.extract_progress_status)
                {
                    let files_info = [];
                    _.forEach(files, (file) => {
                        files_info.push({
                            name: _.isUndefined(file) ? null : file.name,
                            size: _.isUndefined(file) ? null : file.size,
                            type: _.isUndefined(file) ? null : file.type
                        });
                    });
                    let event_param = {
                        status: 'success_multiple',
                        response: response,
                        files_info: files_info
                    };
                    window.eventHub.$emit(this.extract_progress_status_event, event_param);
                }
            },
            vsendingMultiple(file, xhr, formData) {
                this.media.sendingMultiple = true;
                if (this.is_debug)
                {
                    console.log('vsendingMuliple:');
                    console.log(file);
                    console.log(xhr);
                    console.log(formData);
                }
                if (this.extract_progress_status)
                {
                    let files_info = [];
                    _.forEach(files, (file) => {
                        if (!_.isUndefined(file))
                        {
                            files_info.push({
                                name: file.name,
                                size: file.size,
                                type: file.type
                            });
                        }
                    });
                    let event_param = {
                        status: 'file_sending_multiple',
                        response: response,
                        files_info: files_info
                    };
                    window.eventHub.$emit(this.extract_progress_status_event, event_param);
                }
            },
            vqueueComplete(file, xhr, formData) {
                this.media.queueComplete = true;
                if (this.is_debug)
                {
                    console.log('vqueueComplete:');
                    console.log(file);
                    console.log(xhr);
                    console.log(formData);
                }
                if (this.extract_progress_status)
                {
                    let event_param = {
                        status: 'queue_completed',
                        xhr: xhr,
                        formData: formData,
                        file_info: {
                            name: _.isUndefined(file) ? null : file.name,
                            size: _.isUndefined(file) ? null : file.size,
                            type: _.isUndefined(file) ? null : file.type
                        }
                    };
                    window.eventHub.$emit(this.extract_progress_status_event, event_param);
                }
            },
            vprogress(totalProgress, totalBytes, totalBytesSent) {
                this.media.progress = true;
                this.media.myProgress = Math.floor(totalProgress);
                if (this.is_debug)
                {
                    console.log('vprogress:');
                    console.log(totalProgress);
                    console.log(totalBytes);
                    console.log(totalBytesSent);
                }
                if (this.extract_progress_status)
                {
                    let event_param = {
                        status: 'file_progress',
                        totalProgress: totalProgress,
                        totalBytes: totalBytes,
                        totalBytesSent: totalBytesSent
                    };
                    window.eventHub.$emit(this.extract_progress_status_event, event_param);
                }
            },
            template: function () {
                return `<div class="dz-preview dz-file-preview">
                    <div class="dz-image">
                        <div data-dz-thumbnail-bg></div>
                    </div>
                    <div class="dz-details">
                        <div class="dz-filename"><span data-dz-name></span></div>
                        <div class="dz-size"><span data-dz-size></span></div>
                    </div>
                    <div class="dz-error-message"><span data-dz-errormessage></span></div>
                    <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                    <div class="dz-success-mark"><i class="fa fa-check"></i></div>
                    <div class="dz-error-mark"><i class="fa fa-window-close"></i></div>
                </div>`;
            },
            thumbnail: (file, dataUrl) => {
                let j, len, ref, thumbnailElement;
                if (file.previewElement) {
                    file.previewElement.classList.remove("dz-file-preview");
                    ref = file.previewElement.querySelectorAll("[data-dz-thumbnail-bg]");
                    for (j = 0, len = ref.length; j < len; j++) {
                        thumbnailElement = ref[j];
                        thumbnailElement.alt = file.name;
                        thumbnailElement.style.backgroundImage = 'url("' + dataUrl + '")';
                    }
                    return setTimeout(((function(_this) {
                        return function() {
                            return file.previewElement.classList.add("dz-image-preview");
                        };
                    })(this)), 1);
                }
            }
        }
    }
</script>
<style>
    .dz-default, .dz-message {
        font-family:"Microsoft JhengHei", Verdana, "Heiti TC", sans-serif!important;
    }

    .dropzone-custom-content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
    }

    .dz-message .dropzone-custom-title {
        margin-top: 0;
        color: #00b782;
    }

    .dz-message .subtitle {
        color: #314b5f;
    }

    .dz-started .dropzone-custom-content {
        display: none;
    }

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Uploader/UploadZone.vue